import { SpaceContext } from '@eggplant/context'
import {
  SPACES,
  useUrlParams
} from '@eggplant/routing'
import type { SpaceRouteUrlQuery } from '@eggplant/types'
import { navigate } from '@reach/router'
import {
  useContext,
  useEffect
} from 'react'
import Router from '../../Router'
import Spaces from '../../Spaces/Spaces'
import { pathToRetainUponRefresh } from './constants'

const SpaceCheckpoint = () => {
  const spaceContext = useContext(SpaceContext)
  const [{ loginSpaceId }, setUrlParams] = useUrlParams<SpaceRouteUrlQuery>()

  const renderSpaceRoute = () => !!spaceContext?.selectedSpaceId || loginSpaceId
    ? <Router />
    : <Spaces />

  useEffect(() => {
    if (loginSpaceId) {
      spaceContext?.setSelectedSpaceId(loginSpaceId)
      setUrlParams({ loginSpaceId: '' })

      return
    }

  }, [spaceContext, loginSpaceId, setUrlParams])

  useEffect(() => {
    if (loginSpaceId) {

      return
    }

    const isPreventNavigate = pathToRetainUponRefresh.some(path => window.location.pathname.startsWith(path))

    if (isPreventNavigate && spaceContext?.selectedSpaceId) {
      spaceContext.setSelectedSpaceId('')

      return
    }

    // when no selectedSpaceId navigate to SPACES route
    if (!isPreventNavigate && !spaceContext?.selectedSpaceId) {
      void navigate(`/${SPACES}`)
    }
  }, [spaceContext, loginSpaceId])

  return renderSpaceRoute()
}

export default SpaceCheckpoint
